import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  state() {
    return {
      session: {
        id: ""
      },
      navInfo: {
        title: "",
        desctiption: ""
      },
      
      tenant: {
        id: "",
      },
      todo: {
        drawer: false,
        edit: false,
        data: null,
        size: "300px",
      },
      notice: {
        drawer: false,
        edit: false,
        data: null,
        size: "300px",
        linkedId: "",
        treePlace: ""
      },
      inspectForm: {
        sk: null,
        isCopy: false

      },
      project: {
      },
      projectEdit: {
        mode: null //1:新規 2:編集
      },
      editUserParams: {
        editUserId: null,
        createFlg: false,
        fromNavbar: false,
      },
      user: "",
      loginUser: {},
      selectedNode: null,
      measureDetailData: null,
      maintenance: {
        message: "",
        start: "",
        end: "",
      },
      tenantStorage: null,
      toast: {
        title: "",
        message: ""
      },
      loginFlg: false,
    };
  },

  mutations: {
    setToast(state, toast) {
      state.toast = toast
    },
    setSession(state, session) {
      state.session = session
    },
    setNavInfo(state, navInfo) {
      state.navInfo = navInfo
    },
    setTenant(state, tenant) {
      state.tenant = tenant;
    },
    setUser(state, user) {
      state.user = user;
    },
    setTodo(state, todo) {
      state.todo = todo;
    },
    setNotice(state, notice) {
      state.notice = notice;
    },
    setUserinfo(state, loginUser) {
      state.loginUser = loginUser;
    },
    setProject(state, project) {
      state.project = project;
    },
    setProjectEdit(state, projectEdit) {
      state.projectEdit = projectEdit
    },
    setSelectedNode(state, node) {
      state.selectedNode = node;
    },
    setMeasureData(state, measureDetailData) {
      state.measureDetailData = measureDetailData
    },
    setEditUserParams(state, params) {
      state.editUserParams = params
    },
    setMaintenance(state, maintenance) {
      state.maintenance = maintenance;
    },
    setTenantStorage(state, tenantStorage) {
      state.tenantStorage = tenantStorage
    },
    setInspectForm(state, inspectForm){
      state.inspectForm = inspectForm
    },
    setLoginFlg(state, loginFlg){
      state.loginFlg = loginFlg
    }
  },
  actions: {},
  getters: {
    getLoginFlg(state) {
      return state.loginFlg
    } 
  },
  modules: {},
  plugins: [
    createPersistedState({
      // ストレージのキーを指定。デフォルトではvuex
      key: `equtcloud-${process.env.NODE_ENV}`,
      // ストレージの種類を指定する。デフォルトではローカルストレージ
      storage: window.sessionStorage,
    }),
  ],
});